import { useContext } from "react";

import { DateTimeUtils, Person, Table } from "dyl-components";

import { StringUtils } from "utils";

import QuoteID from "shared/QuoteID";
import { QuoteBuilderContext } from "shared/context/QuoteBuilderProvider";
import { useParams } from "react-router-dom";
import { Icon, Popup } from "semantic-ui-react";

const OrderColumns = ({ order }) => {
    const { account_id } = useParams();

    const { onEditOrder, onViewInvoice } = useContext(QuoteBuilderContext);

    const formatStatus = (status) => {
        return (status || "").split("_").map(word => StringUtils.capitalize(word)).join(" ");
    }

    return (
        <>
            <Table.Cell>
                <div>
                    <b>
                        {DateTimeUtils.formatEpoch(
                            order.created,
                            DateTimeUtils.WORD_DATE_FORMAT
                        )}
                    </b>
                </div>
                <div>
                    <b>
                        {DateTimeUtils.formatEpoch(
                            order.created,
                            DateTimeUtils.TIME_FORMAT
                        )}
                    </b>
                </div>
            </Table.Cell>
            <Table.Cell>
                {order.latest_invoice && (
                    <>
                        <div>
                            <b>
                                {DateTimeUtils.formatEpoch(
                                    order.latest_invoice,
                                    DateTimeUtils.WORD_DATE_FORMAT
                                )}
                            </b>
                        </div>
                        <div>
                            <b>
                                {DateTimeUtils.formatEpoch(
                                    order.latest_invoice,
                                    DateTimeUtils.TIME_FORMAT
                                )}
                            </b>
                        </div>
                    </>
                )}
            </Table.Cell>
            <Table.Cell>
                {order.created_by.username ? (
                    <Person
                        username={order.created_by.username}
                        email={order.created_by_email}
                        isInactiveUser={!order.created_by.active}
                    />
                ) : (
                    <Icon
                        className='fas fa-robot AutomationIcon'
                        circular
                        size='large'
                    />
                )}
            </Table.Cell>
            <Table.Cell>
                <QuoteID
                    hasPdf={order.latest_invoice_id}
                    onEditQuote={() => {
                        onEditOrder(order.order_id, account_id);
                    }}
                    id={order.order_id}
                    onViewProposal={() => {
                        onViewInvoice(order.latest_invoice_id)
                    }}
                    otherInfo={(
                        order.has_canceled && (
                            <Popup
                                content={"Has cancellations"}
                                inverted
                                position="top center"
                                trigger={<Icon className="fas fa-info-circle" color="orange" />}
                            />
                        )
                    )}
                />
            </Table.Cell>
            <Table.Cell>
                {formatStatus(
                    order.status
                )}
            </Table.Cell>
            <Table.Cell>
                {order.subtotal &&
                    `$${StringUtils.formatDecimal(String(order.subtotal), true)}`}
            </Table.Cell>
        </>
    );
}

export default OrderColumns;
